export default class Review {
  constructor(
    id,
    comment,
    workerID,
    companyID,
    workLifeBalance,
    compensationBenefits,
    professionalSkills,
    managment,
    companyCulture,
    isAnonymous,
    user
  ) {
    this.id = id;
    this.comment = comment;
    this.workerID = workerID;
    this.companyID = companyID;
    this.workLifeBalance = workLifeBalance;
    this.compensationBenefits = compensationBenefits;
    this.professionalSkills = professionalSkills;
    this.managment = managment;
    this.companyCulture = companyCulture;
    this.isAnonymous = isAnonymous;
    this.user = user;
  }

  static fromJson(json) {
    return new Review(
      json.id,
      json.comment,
      json.workerID,
      json.companyID,
      json.workLife_balance,
      json.compensation_benefits,
      json.professional_skills,
      json.managment,
      json.company_culture,
      json.is_anonymous,
      json.user
    );
  }
}